/**
 * Utility for formatting currency values dynamically.
 */

/**
 * Formats a numeric value as currency based on the provided currency code.
 * Falls back to USD if the currency code is invalid or missing.
 */
export const formatCurrency = (
    value: number | undefined | null,
    currencyCode: string = 'USD',
    hideValue: boolean = false
): string => {
    if (hideValue) return '***';
    if (value === undefined || value === null) return '-';

    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode || 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    } catch {
        // Fallback if currency code is invalid
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }
};

/**
 * Returns a compact currency prefix/symbol if needed for manual formatting.
 */
export const getCurrencySymbol = (currencyCode: string = 'USD'): string => {
    switch (currencyCode) {
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'JPY':
            return '¥';
        default:
            return '$';
    }
};
